import {Component, OnInit} from '@angular/core';
import {HelperProvider} from '../providers/helper.provider';
import {Page} from '../model/page';
import {RestService} from '../providers/rest.service';
import {KullaniciGrup} from '../model/kullanici-grup';
import {Router} from '@angular/router';

@Component({
  selector: 'app-kullanici-gruplar',
  templateUrl: './kullanici-gruplar.component.html',
  styleUrls: ['./kullanici-gruplar.component.css']
})
export class KullaniciGruplarComponent implements OnInit {
  kullaniciGrup: KullaniciGrup[] = null;

  constructor(private helperProvider: HelperProvider,
              private restService: RestService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.KullaniciGruplari);
    this.getKullaniciGruplar();
  }


  kaldir(s: KullaniciGrup) {
    if (confirm(`${s.isim} kullanıcı grubunu silmek istediğinize emin misiniz?`)) {
      this.restService.kullaniciGrupSil(s.id).subscribe(res => {
        if (res) {
          this.getKullaniciGruplar();
        }
      });
    }
  }

  incele(s: KullaniciGrup) {
    this.router.navigate(['kullanici-grup'], {queryParams: {id: s.id}});
  }

  new() {
    this.router.navigate(['kullanici-grup'], {queryParams: {id: '0'}});
  }

  getKullaniciGruplar() {
    this.restService.kullaniciGruplar().subscribe(res => {
      this.kullaniciGrup = res;
    });
  }
}
